import React, {useEffect, useMemo, useState} from 'react';
import {connect} from 'react-redux';
import {setCurrentSubscriber} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import {isMobile} from 'react-device-detect';
import {prepareSameWindowUrl} from '../../../utilities/StringHelpers/StringHelpers';
import {abroadInsuranceCreateReportShowDetails} from '../CollaborationInsuranceBlock/abroadInsurancReports';
import {gaReportAbroadInsurance} from '../CollaborationInsuranceBlock/abroadInsuranceGA';
import {abroadInsuranceEnum} from '../CollaborationInsuranceBlock/abroadInsuranceGAEnum';

const SelfCareAbroadInsurance = ({
  userDetails,
  insuranceData,
  subscriber,
  customerType,
  context,
  setCurrentSubscriber,
  linkForCollaborationInsurance,
}) => {
  const [expDate, setExpDate] = useState(null);

  useEffect(() => {
    if (insuranceData?.exist) {
      const date = insuranceData.expirationDate;
      const formattedDate = date ? `${date.slice(6, 8)}.${date.slice(4, 6)}.${date.slice(0, 4)}` : '';
      setExpDate(formattedDate);

      if (subscriber && formattedDate) {
        const channel = customerType?.isBusiness && !customerType?.isPrivate ? 'WebsiteBusiness' : 'WebsitePrivate';
        fillReports(channel, 'Ongoing', 'Insurance Info Displayed', formattedDate, abroadInsuranceEnum.InsuranceExist);
      }
    }
  }, []);

  function fillReports(webType,status,reportActionDetails,date,reportEnum){
    abroadInsuranceCreateReportShowDetails(
      webType,
      status,
      reportActionDetails,
      date,
      `${userDetails?.firstName} ${userDetails?.lastName}`,
      '',
      subscriber,
      userDetails?.IDNumber,
    );
    gaReportAbroadInsurance(reportEnum);
  }

  const actionClicked = (webType,status,date,reportActionDetails,reportEnum) => {
    prepareSameWindowUrl(linkForCollaborationInsurance, context);
    fillReports('WebsitePrivate','Completed',reportActionDetails,'',reportEnum);
  };


  return (
    <div className='package-box'>
      <div className='top-box extra-top-box'>
        <div className='addon-title-1'>יש לך ביטוח נסיעה לחו"ל</div>
        <div className='addon-title-2'>
          למנוי
          <span style={{fontWeight: 'bold'}}>{` ${subscriber} `}</span>
          קיים ביטוח נסיעה לחו"ל {expDate ? ` עד ` : ''}
          <span>&nbsp;</span>
          <span style={{fontWeight: 'bold'}}>{expDate}</span>
        </div>
      </div>
      <div className='action-container'>
        <div
          className='more-details-action'
          onClick={() => {
            setCurrentSubscriber(subscriber);
            actionClicked('Insurance Info Clicked', abroadInsuranceEnum.InfoButtonHullSheli);
          }}>
          {'פרטים נוספים > '}
        </div>
        <div
          className='go-to-insurance-page-action'
          onClick={() => {
            actionClicked('Go To Insurance Page Clicked', abroadInsuranceEnum.AnotherInsButton);
          }}>
          {' מישהו טס איתך? לרכישת ביטוח למנוי נוסף > '}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userDetails: state.authentication?.loginData?.userDetails,
    insuranceData: state.cellcomAbroad.abroadPermanentInsuranceSocData,
    subscriber: state.selfcarePage?.selectedSubscriber?.productSubscriberNo,
    customerType: state.welcomeBlock?.welcomeState?.customerType,
  };
};

const mapDispatchToProps = {
  setCurrentSubscriber,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelfCareAbroadInsurance);
